import { render, staticRenderFns } from "./ProductsNavbar.vue?vue&type=template&id=6179392e"
import script from "./ProductsNavbar.vue?vue&type=script&lang=js"
export * from "./ProductsNavbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports